import { CounterOfferGroupsView, useCounterOfferGroups } from "../../components/counter-offer-groups";

export const MyCounterOffersList = () => {
  const logic = useCounterOfferGroups();
  return <CounterOfferGroupsView {...logic} />;
};
